export function useCalendarGridDayPopoverHandlers({
  onClickItem,
  onClickSecondaryLabel,
  onClose,
}) {
  function handleClickItem(item, event) {
    onClose()

    onClickItem(item, event)
  }

  function handleClickSecondaryLabel(item) {
    onClose()

    onClickSecondaryLabel(item)
  }

  return {
    handleClickItem,
    handleClickSecondaryLabel,
  }
}
